const CSV_EXTENSION = ".csv";

/** Ensures generated CSV content is downloaded with a CSV file extension. */
export function ensureCSVFilename(filename: string): string {
  return filename.toLowerCase().endsWith(CSV_EXTENSION)
    ? filename
    : `${filename}${CSV_EXTENSION}`;
}
